import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const COMPANY = {
  name: "Italian Mood",
  vat: "IT02234750442",
  cf: "LCDGLC74L24H321Z",
  address: "Via Gabriele d'Annunzio 28, 63074 San Benedetto del Tronto (AP)",
  email: "partners@archi-hub.it",
};

function tplHtml(raw, vars) {
  return Object.entries(vars || {}).reduce(
    (acc, [k, v]) => acc.replace(new RegExp(`{{\\s*${k}\\s*}}`, "g"), String(v)),
    raw
  );
}

function Html({ html }) {
  return <span dangerouslySetInnerHTML={{ __html: html }} />;
}

export default function Terms() {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.startsWith("it") ? "it" : "en";
  const h9Body = t("legal.terms.h9_body");
  const [h9Before, h9After] = h9Body.split("{{privacyLink}}");
  return (
    <div className="min-h-[100svh] pt-32 pb-20 bg-cream" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-[11px] tracking-[0.3em] uppercase text-slate1 inline-flex items-center gap-2"><FileText size={12} /> {t("legal.terms.pre")}</div>
        <h1 className="mt-4 font-display text-4xl lg:text-5xl font-light text-ink">{t("legal.terms.title")}</h1>
        <p className="mt-3 text-sm text-slate1">{t("legal.terms.updated")}</p>

        <div className="prose prose-slate max-w-none mt-10 space-y-6 text-ink/90 text-[15px] leading-relaxed">
          <p><Html html={tplHtml(t("legal.terms.intro"), { company: COMPANY.name })} /></p>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h1")}</h2>
            <p><Html html={t("legal.terms.h1_p1")} /></p>
            <p><Html html={t("legal.terms.h1_p2")} /></p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h2")}</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>{t("legal.terms.h2_li1")}</li>
              <li>{t("legal.terms.h2_li2")}</li>
              <li>{t("legal.terms.h2_li3")}</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h3")}</h2>
            <p>{t("legal.terms.h3_intro")}</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><Html html={t("legal.terms.h3_li1")} /></li>
              <li><Html html={t("legal.terms.h3_li2")} /></li>
              <li><Html html={t("legal.terms.h3_li3")} /></li>
            </ul>
            <p><Html html={t("legal.terms.h3_outro")} /></p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h4")}</h2>
            <p><Html html={t("legal.terms.h4_p1")} /></p>
            <p>{t("legal.terms.h4_p2")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h5")}</h2>
            <p>{t("legal.terms.h5_body")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h6")}</h2>
            <p>{t("legal.terms.h6_body")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h7")}</h2>
            <p>{t("legal.terms.h7_body")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h8")}</h2>
            <p><Html html={tplHtml(t("legal.terms.h8_body"), { email: COMPANY.email })} /></p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h9")}</h2>
            <p>
              {h9Before}
              <Link to="/privacy" className="underline">{t("footer.privacy")}</Link>
              {h9After || ""}
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h10")}</h2>
            <p>{t("legal.terms.h10_body")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.terms.h11")}</h2>
            <p>{t("legal.terms.h11_body")}</p>
          </section>

          {lng === "en" && (
            <p className="text-xs italic text-slate1 pt-6 border-t border-ink/10 mt-10">{t("legal.terms.note")}</p>
          )}
        </div>

        <div className="mt-12 text-center">
          <Link to="/" className="inline-flex items-center gap-2 bg-ink text-cream px-6 py-3 text-[12px] tracking-[0.2em] uppercase rounded-sm">
            {t("legal.back_home")}
          </Link>
        </div>
      </div>
    </div>
  );
}
